import React, {useEffect, useState} from 'react';
import {Button, Form, Input, message, Select, Spin, Upload} from 'antd';
import _ from 'lodash';

import {UploadOutlined} from '@/icons';
import {getTokens} from '@/util/AuthStore';
import {API_ROOT} from '@/env';
import {useExtraNewsStore} from './context';
import {getEntrypoint} from './extra-news';

function ExtraNewsUpload() {
    const [loading, setLoading] = useState(false);
    const [store, dispatch] = useExtraNewsStore();
    const entrypoint = store.entrypointsById[store.currentTmpId];
    const currentNews = store.newsById[store.currentTmpId];

    const {entrypointId, entrypointPath} = currentNews || {};
    const btnText = entrypointId ? '重新上传' : '上传图文 zip 包';
    const UPLOAD_URL = `${API_ROOT}/extra/news/upload`;

    useEffect(() => {
        if (!entrypoint && entrypointId) {
            getEntrypoint(entrypointId).then(({data}) => {
                dispatch(['updateEntrypointPaths', data]);
            });
        }
    }, [dispatch, entrypoint, entrypointId]);

    function beforeUpload() {
        setLoading(true);
        return true;
    }

    function onUploadChange({file}) {
        if (file.status === 'done') {
            setLoading(false);

            const {response} = file;
            if (response.status !== 200) {
                message.error(response.message);
                return;
            }

            console.log('onUploadChange', file);
            console.log('data', response.data);

            if (_.isEmpty(response.data?.paths)) {
                message.error('上传的 zip 包中未找到任何 HTML 文件');
                return;
            }
            dispatch(['updateEntrypointPaths', response.data]);
        }
    }

    function onChange(path) {
        dispatch(['updateEntrypoint', {entrypointId: entrypoint?.id, entrypointPath: path}]);
    }

    function onPreviewClick() {
        console.log(entrypoint, entrypointId);
        window.open(`${entrypoint.urlRoot}/${entrypointId}/${entrypointPath}`);
    }

    return (
        <Spin spinning={loading}>
            <Form.Item hidden name="entrypointId">
                <Input />
            </Form.Item>

            <Upload
                action={UPLOAD_URL}
                // accept="*.zip"
                showUploadList={false}
                onChange={onUploadChange}
                beforeUpload={beforeUpload}
                headers={{
                    Authorization: `Bearer ${getTokens().access_token}`, // 获取 token 放在这儿可以在执行的时候再读取
                }}
            >
                <Button type="primary" icon={<UploadOutlined />}>
                    {btnText}
                </Button>
            </Upload>

            {entrypoint && (
                <div style={{display: 'flex', marginTop: 24}}>
                    <Form.Item
                        name="entrypointPath"
                        label="入口页"
                        style={{flex: 1}}
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Select onChange={onChange} placeholder="选择入口页">
                            {entrypoint?.paths.map(path => (
                                <Select.Option key={path} value={path}>
                                    {path}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Button disabled={!entrypointId} onClick={onPreviewClick}>
                        预览
                    </Button>
                </div>
            )}
        </Spin>
    );
}

export default ExtraNewsUpload;
